import { components } from 'gridstrap/lib/gs-components';
import { GSTemplate } from './template';
import { GSTemplateService } from './template-service';

components.register({
	selector: '.gs-Template',
	controller: GSTemplate
});

export const templates = new GSTemplateService();
